import { type ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

import { useAuth } from '../../hooks/useAuth'
import { ROUTES } from '../types'

interface LicenseGuardProps {
  children: ReactNode
  requiredLicenses: string[]
}

export function LicenseGuard({ children, requiredLicenses }: LicenseGuardProps) {
  const { user } = useAuth()

  const userLicenses = user?.licenses || []
  const hasRequiredLicense = requiredLicenses.some(license => userLicenses.includes(license))

  if (!hasRequiredLicense) {
    return <Navigate to={ROUTES.HOME} replace />
  }

  return <>{children}</>
}
